import React from "react";
import PropTypes from "prop-types";

// this is another "stateless functional component"
// so there is no "this" thus props.authenticate instead of this.props.authenticate
const Login = props => (
    <nav className="login">
        <h2>Inventory Login</h2>
        <p>Sign in to manage your store's inventory.</p>
        <button className="github" onClick={() => props.authenticate("Github")}>
            Log In With GitHub
        </button>
        <button className="twitter" onClick={() => props.authenticate("Twitter")}>
            Log In With Twitter
        </button>
        <button className="facebook" onClick={() => props.authenticate("Facebook")}>
            Log In With Facebook
        </button>
    </nav>
);

// specify the type and that it is required
Login.propTypes = {
    authenticate: PropTypes.func.isRequired
};

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js